<template>
  <div class="sponsor" data-cont="small">
    <div class="sponsor__logo-cont"
      v-for="(picture, index) in data.list"
      :key="index"
    >
      <a :href="picture.link" rel="noopener" target="_blank" aria-label="Sponsor">
        <BasePicture
          class="sponsor__logo"
          :data="Object.assign(picture, { tagImg: true })"
          :animation="'sponsorLogo'"
        />
      </a>
    </div>
  </div>
</template>

<script>
import BasePicture from '@/components/BasePicture';


export default {
  name: 'sponsor',

  components: {
    BasePicture,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.sponsor {
  position: relative;
  width: 100%;
  padding: 80px 0 0 0;

  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: row wrap;

  &__logo-cont {
    position: relative;
    width: 50%;
    height: 100px;
    margin-bottom: 40px;

    display: flex;
    align-items: stretch;
    justify-content: center;

    @include mq(ipadP) {
      width: 25%;
      flex: 0 0 25%;
    }

    @include mq(ds) {
      width: 16.6%;
      flex: 0 0 16.6%;
    }

    a {
      position: relative;
      width: 100%;

      display: inline-flex;
      align-items: center;
      justify-content: center;

      opacity: 0.6;

      transition: all 0.4s $global-ease;

      &:hover {
        opacity: 1;
      }
    }
  }

  &__logo {
    width: 90%;
  }
}
</style>

<style lang="scss">
.sponsor__logo img {
  max-width: 120px;
  max-height: 65px;
}
</style>

